import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "central-background" }
const _hoisted_2 = { class: "py-0 d-flex justify-content-center third-level-nav" }
const _hoisted_3 = { class: "horizontal-nav-bar rounded-top" }
const _hoisted_4 = {
  class: "d-flex bg-white rounded-top",
  id: "solution-tab",
  role: "tablist",
  "aria-orientation": "horizontal"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = {
  tabindex: "0",
  href: "javascript:void(0);",
  role: "button"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circle text-primary font-size-sm ms-2" }, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "d-flex justify-content-start ms-auto py-2 px-3" }
const _hoisted_10 = {
  class: "tab-content",
  id: "v-pills-tabContent"
}
const _hoisted_11 = { class: "px-3 mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HuvSfvStatusReportHos = _resolveComponent("HuvSfvStatusReportHos")!
  const _directive_custom_popover = _resolveDirective("custom-popover")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
              return (_openBlock(), _createElementBlock("a", {
                class: _normalizeClass(`nav-link d-flex justify-content-between align-items-center 
                                active
                            `),
                id: `v-pills-${tab.id}`,
                "data-toggle": "pill",
                href: "javascript:void(0)",
                role: "tab",
                key: tab.id,
                "aria-selected": "true"
              }, [
                _createTextVNode(_toDisplayString(tab.name) + " ", 1 /* TEXT */),
                _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_6, _hoisted_8)), [
                  [_directive_custom_popover, { content: _ctx.hopeDeclaration }]
                ])
              ], 8 /* PROPS */, _hoisted_5))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToReportCenter()))
              }, " Report Center ")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("section", _hoisted_11, [
          _createVNode(_component_HuvSfvStatusReportHos)
        ])
      ])
    ])
  ]))
}